import { Fragment } from 'react';

import { withProps } from 'recompose';
import { FormattedMessage } from 'react-intl';

import NetworkConnectivity, { NETWORK_STATES } from '@mindtickle/detect-online/NetworkConnectivity';
import { errorToast as ErrorToast, successToast as SuccessToast } from '@mindtickle/toast';

import messages from '../../messages';

const ConnectionNotifier = ({
  currNetworkStatus,
}: {
  currNetworkStatus: keyof typeof NETWORK_STATES;
}) => (
  <Fragment>
    {currNetworkStatus === NETWORK_STATES.OFFLINE &&
      ErrorToast({
        message: <FormattedMessage {...messages.ERROR_CONNECTING_INTERNET} />,
        autoHide: false,
      })}
    {currNetworkStatus === NETWORK_STATES.TRANSITIONED_TO_ONLINE &&
      SuccessToast({
        message: <FormattedMessage {...messages.ONLINE_AGAIN} />,
        timeout: 2000,
      })}
  </Fragment>
);

ConnectionNotifier.propTypes = {
  currNetworkStatus: NETWORK_STATES,
};

const addProps = withProps(() => ({
  ComponentToNotify: ConnectionNotifier,
}));

export default addProps(NetworkConnectivity);
